import { render, staticRenderFns } from "./CardTeacherInfo.vue?vue&type=template&id=1f8cb218&scoped=true&"
import script from "./CardTeacherInfo.vue?vue&type=script&lang=js&"
export * from "./CardTeacherInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardTeacherInfo.vue?vue&type=style&index=0&id=1f8cb218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8cb218",
  null
  
)

export default component.exports